import React, { useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { API, get, idelTime } from "./config";
import { Modal, Button } from "react-bootstrap";
import useIdleTimeout from "./components/useIdleTimeout";
import { TrustProvider } from "./lib/context/TrustContext";
import { useOrganization } from "./lib/context/OrganisationContext";
import UnauthorisedAccess from "./UnauthorisedAccess";
import AMLCTFAccess from "./AMLCTFAccess";
import { useUser } from "./lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "./lib/PermissionConditions";

const ProtectedRoute = ({
  notSubscription = false,
  component: Component,
  AMLCTFPage = false,
  type,
  ...rest
}) => {
  // * Check the user is logged in and access the inner pages of the portal.

  const params = useParams();
  const token = localStorage.getItem("ts-auth-token");
  const trustId = params?.trust_id;
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  const tfaCheck = localStorage.getItem("ts-auth-tfa");

  // const trustData =
  //   localStorage.getItem("trustData") &&
  //   JSON.parse(decrypt(localStorage.getItem("trustData")));
  // const roleType = localStorage.getItem("roleType");
  // const navigate = useNavigate();

  // Idle Logic start
  const logout = () => {
    get(API.LOGOUT)
      .then((response) => {
        if (response.status === 200) {
          localStorage.clear();
          window.location.href = "/";
        }
      })
      .catch(() => {
        var error = {};
        error["bt_error"] =
          "There is some issue with request, please try after some time.";
        this.setState({ errors: error });
      });
  };

  const [openModal, setOpenModal] = useState(false);
  const handleIdle = () => {
    setOpenModal(true);
    localStorage.clear();
  };

  // Here idleTime is in minutes
  const { idleTimer } = useIdleTimeout({
    onIdle: handleIdle,
    idleTime: idelTime,
  });

  const handleLogout = () => {
    idleTimer.reset();
    logout();
    setOpenModal(false);
  };
  // const handleNavigate = useCallback(() => {
  //   type === "builder" &&
  //     roleType === "Accounting Firm" &&
  //     navigate("/vendors");
  // }, [navigate, roleType, type]);
  // useEffect(() => {
  //   handleNavigate();
  // }, [handleNavigate]);

  // Idle Logic end
  if (token) {
    if (tfaCheck === "2" || tfaCheck === "-1") {
      if (trustId) {
        return organizationData?.organizationData?.is_subscribed ? (
          <>
            <TrustProvider>
              <div className="trust-section">
                {/* {trustData ? <Component {...rest} /> : <UnauthorisedAccess />} */}
                <Component {...rest} />
                {openModal && (
                  <Modal
                    show={openModal}
                    onHide={handleLogout}
                    size="lg"
                    dialogClassName="modal-50w small-popup review-popup small-review"
                    aria-labelledby="contained-modal-title-vcenter"
                    className="project-section"
                    centered
                  >
                    <Modal.Header closeButton style={{ marginBottom: "10px" }}>
                      Your session is expired
                    </Modal.Header>
                    <Modal.Body>
                      <div style={{ margin: "0 10px" }}>
                        <p>
                          Your session is expired. You are automatically signed
                          out.
                        </p>
                        <p>
                          Expired due to the reason that user is idle for{" "}
                          {idelTime} mins.
                        </p>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="reset"
                        onClick={handleLogout}
                      >
                        Login Again
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
              </div>
            </TrustProvider>
          </>
        ) : (
          <>
            <TrustProvider>
              <UnauthorisedAccess />
            </TrustProvider>
          </>
        );
      } else if (AMLCTFPage) {
        return amlCTFEnable ? (
          <>
            <TrustProvider>
              <div className="trust-section">
                {/* {trustData ? <Component {...rest} /> : <UnauthorisedAccess />} */}
                <Component {...rest} />
                {openModal && (
                  <Modal
                    show={openModal}
                    onHide={handleLogout}
                    size="lg"
                    dialogClassName="modal-50w small-popup review-popup small-review"
                    aria-labelledby="contained-modal-title-vcenter"
                    className="project-section"
                    centered
                  >
                    <Modal.Header closeButton style={{ marginBottom: "10px" }}>
                      Your session is expired
                    </Modal.Header>
                    <Modal.Body>
                      <div style={{ margin: "0 10px" }}>
                        <p>
                          Your session is expired. You are automatically signed
                          out.
                        </p>
                        <p>
                          Expired due to the reason that user is idle for{" "}
                          {idelTime} mins.
                        </p>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="reset"
                        onClick={handleLogout}
                      >
                        Login Again
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
              </div>
            </TrustProvider>
          </>
        ) : (
          <>
            <TrustProvider>
              {AMLCTFModuleConditonIndustry(organizationData) ? <AMLCTFAccess /> : <UnauthorisedAccess />}
            </TrustProvider>
          </>
        );
      } else {
        return (
          <>
            <TrustProvider>
              {/* <Header /> */}
              <Component {...rest} />
            </TrustProvider>
            {openModal && (
              <Modal
                show={openModal}
                // onHide={stay}
                onHide={handleLogout}
                size="lg"
                dialogClassName="modal-50w small-popup review-popup small-review"
                aria-labelledby="contained-modal-title-vcenter"
                className="project-section"
                centered
              >
                <Modal.Header closeButton style={{ marginBottom: "10px" }}>
                  Your session is expired
                </Modal.Header>
                <Modal.Body>
                  <p>
                    Your session is expired. You are automatically signed out.
                  </p>
                  <p>
                    Expired due to the reason that user is idle for {idelTime}{" "}
                    mins.
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="reset"
                    onClick={handleLogout}
                  >
                    Login Again
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </>
        );
      }
    } else {
      return <Navigate to="/2fa" />;
    }
  } else {
    return <Navigate to="/#" />;
  }
};

export default ProtectedRoute;
